import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import { Card, Typography } from 'seagull';
import styles from './CommonComponents.module.scss';
const SuccessIcon = ()=>/*#__PURE__*/ _jsxs("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M11.7305 7.23047L7.79303 11.168L5.82428 9.19922",
                stroke: "currentColor",
                strokeWidth: "1.3",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 0.65C13.6116 0.65 17.35 4.38842 17.35 9C17.35 13.6116 13.6116 17.35 9 17.35C4.38842 17.35 0.65 13.6116 0.65 9C0.65 4.38842 4.38842 0.65 9 0.65Z",
                stroke: "currentColor",
                strokeWidth: "1.3",
                strokeMiterlimit: "10"
            })
        ]
    });
export const SuccessBox = (props)=>{
    const { className, children, testId } = props, rest = _object_without_properties(props, [
        "className",
        "children",
        "testId"
    ]);
    return /*#__PURE__*/ _jsxs("div", _object_spread_props(_object_spread({}, rest), {
        "data-testid": testId,
        className: cn(className, styles.sucessBox),
        children: [
            /*#__PURE__*/ _jsx(SuccessIcon, {}),
            /*#__PURE__*/ _jsx(Typography, {
                style: {
                    marginInlineStart: '8px'
                },
                children: children
            })
        ]
    }));
};
export const ErrorBox = (props)=>{
    const { className, children, testId } = props, rest = _object_without_properties(props, [
        "className",
        "children",
        "testId"
    ]);
    return /*#__PURE__*/ _jsx("div", _object_spread_props(_object_spread({}, rest), {
        "data-testid": testId,
        className: cn(className, styles.errorBox),
        children: children
    }));
};
export const ImportCard = (props)=>{
    const { children, title, subtitle, actionsStart, actionsEnd } = props;
    return /*#__PURE__*/ _jsxs(Card, {
        bi: {
            name: 'import_wizard_card'
        },
        padding: "m",
        className: styles.cardRoot,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    title && /*#__PURE__*/ _jsx(Typography, {
                        variant: "h6",
                        weight: "normal",
                        children: title
                    }),
                    subtitle && /*#__PURE__*/ _jsx(Typography, {
                        children: subtitle
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                children: children
            }),
            (actionsStart || actionsEnd) && /*#__PURE__*/ _jsxs("div", {
                className: styles.cardActions,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.cardActionBlock,
                        children: actionsStart
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.cardActionBlock,
                        children: actionsEnd
                    })
                ]
            })
        ]
    });
};
